import { guardNever } from "@hex/common";
import produce, { Draft } from "immer";

import { WorkbenchRegion, WorkbenchRegions } from "./regions.types";

/**
 * Update the region at the given position.
 */
export function updateWorkbenchRegion<
  TLeft extends WorkbenchRegion.Left,
  TBottom extends WorkbenchRegion.Bottom,
  TRight extends WorkbenchRegion.Right,
>(
  state: WorkbenchRegions<TLeft, TBottom, TRight>,
  position: WorkbenchRegion.Position,
  producerFn: (region: Draft<WorkbenchRegion>) => void | Draft<WorkbenchRegion>,
): WorkbenchRegions<TLeft, TBottom, TRight> {
  return produce(state, (regions) => {
    // TS doesn't like when we aren't case-explicit about what draft is assigned to what region
    if (position === "left") {
      regions.left = produce(regions.left, producerFn);
    } else if (position === "bottom") {
      regions.bottom = produce(regions.bottom, producerFn);
    } else if (position === "right") {
      regions.right = produce(regions.right, producerFn);
    } else {
      guardNever(position, position);
    }
    return regions;
  });
}
